import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import AgentCard from "./AgentCard";
import agentsData from "../../data/agentsData";

export default function AgentsList() {
  return (
    <Box
      sx={{
        py: { xs: 3, md: 6 },
        backgroundColor: "var(--color-bg)", // ✅ light theme
        position:"relative"
      }}
    >
      <Container maxWidth="xl">
        {/* SECTION HEADER */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          {/* EYEBROW */}
          <Typography
            sx={{
              color: "var(--color-gold)",
              letterSpacing: "0.28em",
              fontSize: 11,
              mb: 1.5,
              textAlign: { xs: "left", md: "center" },
            }}
          >
            OUR AGENTS
          </Typography>

          {/* HEADING */}
          <Typography
            sx={{
              fontSize: {
                xs: "1.9rem",
                sm: "2.2rem",
                md: "2.8rem",
              },
              fontWeight: 600,
              lineHeight: 1.15,
              maxWidth: 820,
              mx: { xs: 0, md: "auto" },
              mb: { xs: 4, md: 6 },
              textAlign: { xs: "left", md: "center" },
              color: "var(--color-text-primary)",
            }}
          >
            Meet Our{" "}
            <Box component="span" sx={{ color: "var(--color-gold)" }}>
              Trusted Real Estate
            </Box>{" "}
            Advisors
          </Typography>
        </motion.div>

        {/* AGENTS GRID */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "repeat(4, 1fr)",
            },
            gap: { xs: 3, md: 4 },
          }}
        >
          {agentsData.map((agent) => (
            <AgentCard key={agent.id} agent={agent} />
          ))}
        </Box>
      </Container>
      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}
